import logo from './logo.svg';
import './App.css';


function App() {

  const categories = [
    { label: "Vegetarian Curries", key: 1 },
    { label: "Speical Curries", key: 2 },
    { label: "Soup & Salad", key: 3 },
    { label: "Dessert", key: 4 },
    { label: "Vegetarian Chocies", key: 5 },
    { label: "Non-Vegetarian Chocies", key: 6 },
    { label: "Tandoori Specials", key: 7 },
    { label: "Biriyani", key: 8 },
    { label: "Curries & Sauces", key: 9 },
    { label: "Choose One Protien", key: 10 },
    { label: "Sides", key: 11 },
    { label: "Naan Breads", key: 12 },
    { label: "Combos", key: 13 },
    { label: "Drinks", key: 14 },
  ]

  const createMenu = (label, description, price, category, dataURI) =>
  {
      return {label : label , description: description, price: price, category : category , image: dataURI }
  }

  let menu = [
    createMenu("Aloo Mutter", "", 11.99, 1),
    createMenu("Mutter Panner", "", 14.99, 1),
    createMenu("Shahi Panner", "", 14.99, 1),
    createMenu("Chana Masala", "", 12.99, 1),
    createMenu("Egg Plant Bharta", "", 13.99, 1),
    createMenu("Dal Makhni", "", 11.99, 1),
    createMenu("Dal Tadka", "", 11.99, 1),
    createMenu("Kadai Pakora", "", 12.99, 1),
    createMenu("Aloo Gobhi", "", 12.99, 1),
    createMenu("Malai Kofta", "", 13.99, 1),
    createMenu("Panner Tikka Masala", "", 14.99, 1),
    createMenu("Mix Veg Curry", "", 12.99, 1),
    createMenu("Okra Masala (Bhindi)", "", 12.99, 1),


    createMenu("Chicken Curry (bone-in)", "", 13.99, 2),
    createMenu("Butter Chicken", "", 15.99, 2),
    createMenu("Lamb Rogan Josh", "", 17.99, 2),
    createMenu("Chicken Tikka Masala", "", 15.99, 2),
    createMenu("Chole Bhature", "", 15.99, 2),

    createMenu("Dal Soup", "", 9.99, 3),
    createMenu("Mulligatawny Soup ( Veg or Chicken)", "", 9.99, 3),
    createMenu("Kachumber Salad", "", 4.99, 3),
    createMenu("Onion Ring Salad", "", 2.99, 3),


    
    createMenu("Gulab Jamun (3pcs)", "", 4.99, 4),
    createMenu("Rice Pudding (Kheer)", "", 4.99, 4),
    createMenu("Rasmalai (3pcs)", "", 4.99, 4),
 
    
    createMenu("Samosa (for each)", "", 3.50, 5),
    createMenu("Veg Pakora", "", 7, 5),
    createMenu("Samosa Chaat", "", 9.5, 5),
    createMenu("Aloo Tikki Chaat", "", 9.50, 5),
    createMenu("Masala Cauliflower", "", 9.50, 5),
    createMenu("Paneer Pakoras", "", 9.50, 5),
    createMenu("Papri Chaat", "", 9.50, 5),
    createMenu("Veg Chowmein", "", 10.99, 5),
    createMenu("Chilli Paneer", "", 10.99, 5),


    createMenu("Chicken Pakoras", "", 11.99, 6),
    createMenu("Fish Pakoras", "", 10.99, 6),
    createMenu("Prawn Pakoras", "", 12.99, 6),
    createMenu("Chilli Chicken", "", 11.99, 6),
    createMenu("Chilli Fish", "", 11.99, 6),
    createMenu("Chichen Wings", "", 11.99, 6),


    createMenu("Panner Tikka", "", 14.99, 7),
    createMenu("Chicken Tikka", "", 15.99, 7),
    createMenu("Fish Tikka", "", 15.99, 7),
    createMenu("Chicken Malai Tikka", "", 15.99, 7),
    createMenu("Tandoori Chicken (bone-in)", "", 15.99, 7),
    createMenu("Tandoori Prawn", "", 16.99, 7),

    createMenu("Vegetable", "", 15.99, 8),
    createMenu("Chicken", "", 19.05, 8),
    createMenu("Lamb", "", 19.05, 8),
    createMenu("Goat", "", 19.05, 8),
    createMenu("Prawn", "", 19.05, 8),
    createMenu("Paneer Aloo", "", 19.05, 8),


    createMenu("Butter Sauce", "", "", 9),
    createMenu("Korma Sauce", "", "", 9),
    createMenu("Cocounut Curry", "", "", 9),
    createMenu("Vindaloo Sauce", "", "", 9),
    createMenu("Kadai Sauce", "", "", 9),
    createMenu("Saagwala/Spinach Curry", "", "", 9),
    createMenu("Mango Curry", "", "", 9),
    createMenu("Curry Sauce", "", "", 9),

    createMenu("Mix Vegetables", "", "12.99", 10),
    createMenu("Paneer or Tofu", "", "14.99", 10),
    createMenu("Chicken", "", "16.99", 10),
    createMenu("Lamb", "", "17.99", 10),
    createMenu("Goat(bone-in)", "17.99", "", 10),
    createMenu("Fish", "", "15.99", 10),
    createMenu("Prawn", "", "16.99", 10),

    createMenu("Jeera Rice", "", 2.99, 11),
    createMenu("Saffron Rice", "", 3.99, 11),
    createMenu("Mutton Pulao", "", 4.99, 11),
    createMenu("Mix Vegetables", "", 4.99, 11),
    createMenu("Cumin Roasted Potato", "", 4.99, 11),
    createMenu("French Fries", "", 9.5, 11),
    createMenu("Papadum", "", 2.99, 11),
    createMenu("Mango Chutney", "", 0.99, 11),
    createMenu("Pickle", "", 0.99, 11),
    createMenu("Raita", "", 3.99, 11),
    createMenu("Plain Yogurt", "", 3.99, 11),


    createMenu("Butter Naan", "", 2.99, 12),
    createMenu("Garlic Naan", "", 2.99, 12),
    createMenu("Spinach and Paneer Naan", "", 4.99, 12),
    createMenu("Potato Naan (Kulcha)", "", 4.99, 12),
    createMenu("Cheese Naan", "", 4.99, 12),
    createMenu("Chicken Naan", "", 4.99, 12),
    createMenu("Onion Naan", "", 4.99, 12),
    createMenu("Keema Naan", "", 4.99, 12),
    createMenu("Dry Fruit Naan", "", 4.99, 12),
    createMenu("Lacha Paratha", "", 4.99, 12),
    createMenu("Tawa Roti", "", 2.49, 12),
    createMenu("Tandoori Roti", "", 2.49, 12),
    createMenu("Paneer Paratha", "", 4.99, 12),
    createMenu("Bhatura", "", 3.99, 12),

    createMenu("Combo A", "2 Samosa, Dal Makhani, Veg Curry, Rice, 2 Naan, Dessert",40, 13),
    createMenu("Combo B", "2 Samosa, Butter Chicken, Potato, Cauliflower, Rice, 2 Naan, Dessert", 45, 13),
    createMenu("Combo C", "Chicken or Fish Pakora, Butter Chicken, Lamb Vindaloo, Papadum, Rice Pudding", 52, 13),
    createMenu("Gluten Free Combo", "Butter Chicken, Dal Makhani, Veg Pakora,  Papadum, Rice Pudding ", 40, 13),
    createMenu("Dairy Free Combo", "Masala Cauliflower, Chickpea Curry, Coconut Chicken, Rice, 2 Whole Wheat Roti", 42, 13),
    createMenu("Vegan Combo", "Masala Cauliflower, Dal Tadka, Eggplant Bharta, Rice, 2 Whole Wheat Roti", 40, 13),

    createMenu("Chai Tea", "",2.99, 14),
    createMenu("Mango Lassi", "",2.99, 14),
    createMenu("Pop Cans", "",1.99, 14),
    createMenu("Pop 2L", "",5.99, 14),

    ]

   
    const renderItem = (category,index) => {
      return ( <div key={index} className='menu-item-container'>
      <div>
       <span className='category-name'>{category.label}</span>
      </div>
      <div className='item-pos'>                        
         {menu.filter(item => item.category === category.key).map((item,index)=>{
          return <div key={index}  className='menu-item' >
                <span className='item-label'>
                  {item.label}
                </span>
                <span  className='item-desc'>
                  {item.description}
                </span>
                {item.price && <span  className='price'>
                  $ {item.price}
                </span> }
            </div>
         })}
      </div>
      {/* {category.key === 9 && } */}
  </div>);
    }

    const renderItemColumn = (category,index) => {
      return ( <div key={index} className='menu-item-container'>
      <div>
       <span className='category-name'>{category.label}</span>
      </div>
      <div className='item-pos'>                        
         {menu.filter(item => item.category === category.key).map((item,index)=>{
          return <div key={index}  className='menu-item-column' >
                <span className='item-label'>
                  {item.label}
                </span>
                <span className='item-desc'>
                  {item.description}
                </span>
                {item.price && <span className='price'>
                  $ {item.price}
                </span> }
            </div>
         })}
      </div>
      {/* {category.key === 9 && } */}
  </div>);
    }




  return (
    <div className='container-fluid '>
      <div className="banner p-0">
        <div className="name"><span>FourSpice</span></div>   
        <div className="options">
          <span className='options-text'>2637 Quadra St, Victoria, BC V8T 4E3</span>
          <span  className='options-text'>+1 (250) 590-9647</span>
        </div>     
      </div> 
      <div className='row'>     
        <div className='col col-container'>
        {renderItem(categories[0],0)}
        </div>
        <div className='col col-container'>
        {renderItem(categories[1],0)}
        </div>
        <div className='col col-container'>
        {renderItem(categories[2],0)}
        </div>     
      </div>
      <div className='row '>     
        <div className='col col-container'>
        {renderItem(categories[3],0)}
        </div>
        <div className='col col-container'>
        {renderItem(categories[4],0)}
        </div>
        <div className='col col-container'>
        {renderItem(categories[5],0)}
        </div>     
      </div>
      <div className='row'>     
        <div className='col col-container'>
        {renderItem(categories[7],0)}
        </div>
        <div className='col col-container'>
        {renderItem(categories[10],0)}
        </div>
        <div className='col col-container'>
        {renderItem(categories[11],0)}
        </div>
      </div>
      <div className='row'>
          <div className='col col-container'>
             {renderItem(categories[8],0)}
          </div>
        <div className='col custom-arrow'>
              <span className='arrow'>&#8594;</span>
        </div>
        <div className='col col-container'>
        {renderItem(categories[9],0)}
        </div>  
      </div>   
    
      <div className='row'>     
        <div className='col col-container'>
        {renderItemColumn(categories[12],0)}
        </div>
        <div className='col col-container'>
        {renderItem(categories[13],0)}
        </div>  
        {/* <div className='col'>       
        </div>        */}
      </div>
      
    </div>
  );
}

export default App;
